import React from 'react';
import { Link } from 'react-router-dom';
import BrandLogo from './BrandLogo';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand"><BrandLogo decorative /><span>© {new Date().getFullYear()} Sayable Inc. All rights reserved.</span></div>
        <nav aria-label="Legal navigation">
          <Link to="/privacy-policy">Privacy Policy</Link>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
